module.exports = __webpack_public_path__ + "img/nura.84365e21.png";